import React, { Component } from 'react'
import { Box, Text, Grid } from 'grommet'
import { qlikBrand } from '../../branding'

export class ResourceCard extends Component {
  render () {
    const { resource } = this.props
    return (
      <Box background={qlikBrand.flood.slate} pad='small' round>
        <Box>
          <Grid
            rows={['auto', 'auto', 'auto', 'auto', 'auto']}
            columns={['xsmall', 'flex']}
            gap='small'
            fill
            areas={[
              { name: 'componentLabel', start: [0, 0], end: [0, 0] },
              { name: 'component', start: [1, 0], end: [1, 0] },
              { name: 'resourceLabel', start: [0, 1], end: [0, 1] },
              { name: 'resource', start: [1, 1], end: [1, 1] },
              { name: 'descriptionLabel', start: [0, 2], end: [0, 2] },
              { name: 'description', start: [1, 2], end: [1, 2] },
              { name: 'translationProvidedLabel', start: [0, 3], end: [0, 3] },
              { name: 'translationProvided', start: [1, 3], end: [1, 3] },
              { name: 'localesLabel', start: [0, 4], end: [0, 4] },
              { name: 'locales', start: [1, 4], end: [1, 4] }
            ]}
          >
            <Box gridArea='componentLabel' fill justify='center'>
              <Text weight='bold' size='small'>Component</Text>
            </Box>
            <Box gridArea='component' fill justify='center'>
              <Text size='small'>{ resource.componentId.name }</Text>
            </Box>
            <Box gridArea='resourceLabel' fill justify='center'>
              <Text weight='bold' size='small'>Resource</Text>
            </Box>
            <Box gridArea='resource' fill justify='center'>
              <Text size='small'>{ resource.resourceId.name }</Text>
            </Box>
            <Box gridArea='descriptionLabel' fill justify='center'>
              <Text weight='bold' size='small'>Description</Text>
            </Box>
            <Box gridArea='description' fill justify='center'>
              <Text size='small'>{ resource.description }</Text>
            </Box>
            <Box gridArea='translationProvidedLabel' fill justify='center'>
              <Text weight='bold' size='small'>Type</Text>
            </Box>
            <Box gridArea='translationProvided' fill justify='center'>
              <Text size='small'>{resource.translationProvided ? 'Coordinator bug' : 'Vendor bug'}</Text>
            </Box>
            <Box gridArea='localesLabel' fill justify='center'>
              <Text weight='bold' size='small'>Locales</Text>
            </Box>
            <Box gridArea='locales' fill justify='center'>
              <Box direction='row-responsive' wrap gap='xxsmall'>
                {resource.locales.map((locale) => {
                  return <Box key={locale} justify='center' pad='xxsmall' background={qlikBrand.flood.stone} round><Text size='xsmall'>{locale}</Text></Box>
                })}
              </Box>
            </Box>
          </Grid>
        </Box>
      </Box>
    )
  }
}

export default ResourceCard
